@file:Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")

package org.example.project.screens_sys

import androidx.compose.runtime.*
import kotlinx.coroutines.launch
import org.example.project.engineservice.ServiceApi
import org.example.project.enginetabular.TabularScreen
import org.example.project.service.GlobalManager
import org.example.project.service.ZustandManager
import org.example.project.service.currentSaveArt
import org.example.project.utils.All

@Composable
fun SYSCRAuskunft(art: String = currentSaveArt()) {
    val crLiveVersion = GlobalManager.jsonDomainVersion("cr")
    var crs by remember { mutableStateOf<List<All>>(emptyList()) }
    var letzteFilter by remember { mutableStateOf<Map<String, String>?>(null) }
    val scope = rememberCoroutineScope()

    LaunchedEffect(art, crLiveVersion) {
        crs = letzteFilter?.let { filters ->
            runCatching { ServiceApi.searchCr("all", filters) }.getOrDefault(emptyList())
        }.orEmpty()
    }

    val headers = listOf(
        "CR ID",
        "FirmenId",
        "Firma",
        "CR Nummer",
        "CR Art",
        "Betreff",
        "Aufwand (geschätzt)",
        "Aufwand (final)",
        "Zustand"
    )

    TabularScreen(
        screenKey = "CRAuskunft_${art}",
        rollenKey = "CRAuskunft",
        title = "CR Übersicht",
        headers = headers,
        data = crs.map { cr ->
            val artLabel = when {
                cr.crNeuesModul -> "Neues Modul"
                cr.crAenderungAktivModul.isNotBlank() -> "Änderung: ${cr.crAenderungAktivModul}"
                else -> "Änderung"
            }
            cr.id to listOf(
                cr.id,
                cr.firmenId.ifBlank { "-" },
                cr.kunde.ifBlank { cr.firma.ifBlank { "-" } },
                cr.crNummer.ifBlank { "#${cr.id}" },
                artLabel,
                cr.crBeschreibung.ifBlank { "-" },
                if (cr.crAufwandStunden > 0) "${cr.crAufwandStunden} Stunden" else "-",
                if (cr.crAufwandFinal > 0) "${cr.crAufwandFinal} Stunden" else "-",
                ZustandManager.CR.textFor(cr.zustand)
            )
        },
        editable = false,
        hardReadOnly = true,
        includeMetadata = true,
        nonEditableCols = headers.toSet(),
        allowCreate = false,
        allowDelete = false,
        onSearchWithFilters = { filters ->
            scope.launch {
                letzteFilter = filters
                crs = runCatching { ServiceApi.searchCr("all", filters) }.getOrDefault(emptyList())
            }
        },
        dropdownOptions = emptyMap(),
        createRow = { _ -> List(headers.size) { "" } },
        onCommit = { _ -> },
        onDeleteRows = { _ -> },
        onRowClick = { _ -> }
    )
}
